import { createSelector } from '@ngrx/store';
import { getAlioState } from '../reducers';

export const getDrawerState = createSelector(getAlioState, (state) => state.drawer);

export const getDrawerIsOpen = createSelector(getDrawerState, ({ isOpen }) => isOpen);

export const getDrawerWidth = createSelector(getDrawerState, ({ width }) => width);
